import { Data } from "@/types";

const NUMERIC_FIELDS: (keyof Data)[] = [
  "strategicNumberOfProcurements",
  "strategicAverageContractValue",
  "strategicNumberOfEvaluators",
  "strategicAverageDuration",
  "majorNumberOfProcurements",
  "majorAverageContractValue",
  "majorNumberOfEvaluators",
  "majorAverageDuration",
];

const CONTACT_FIELDS: (keyof Data)[] = [
  "firstName",
  "lastName",
  "email",
  "organisation",
];

// RW-60: true only when there is enough input to call the calculateRoi mutation. Used to guard
// /report — if it is reached with no/partial data (deep-link, new tab), redirect to the form
// instead of firing a mutation with undefined fields (which previously rendered a silent dead page).
export function hasRequiredRoiInput(data?: Data): boolean {
  if (!data) return false;
  const numericOk = NUMERIC_FIELDS.every(
    (k) => typeof data[k] === "number" && (data[k] as number) > 0,
  );
  const contactOk = CONTACT_FIELDS.every(
    (k) => typeof data[k] === "string" && (data[k] as string).trim() !== "",
  );
  return numericOk && contactOk;
}
